module.exports = __webpack_public_path__ + "static/media/amazon-tracking-url-location.e40e5e9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/purchase/state-info/amazon-tracking-url-location.jpg
// module id = 1790
// module chunks = 0